import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  LayoutDashboard, FileText, Images, CalendarDays,
  Flame, Settings, LogOut, Menu, X, ChevronRight
} from 'lucide-react';
import './layout-admin.css';

const MENU_ITENS = [
  { href: '/admin',              label: 'Dashboard',     icone: LayoutDashboard },
  { href: '/admin/documentos',   label: 'Documentos',    icone: FileText },
  { href: '/admin/galeria',      label: 'Galeria',       icone: Images },
  { href: '/admin/eventos',      label: 'Eventos',       icone: CalendarDays },
  { href: '/admin/festejo',      label: 'Festejo Junino',icone: Flame },
  { href: '/admin/configuracoes',label: 'Configurações', icone: Settings },
];

export default function LayoutAdmin() {
  const [sidebarAberta, setSidebarAberta] = useState(false);
  const { usuario, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/admin/login');
  };

  return (
    <div className="admin-layout">
      {/* Overlay mobile */}
      {sidebarAberta && (
        <div className="admin-overlay" onClick={() => setSidebarAberta(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarAberta ? 'aberta' : ''}`}>
        <div className="sidebar-logo">
          <div className="sidebar-diamante"><span>★</span></div>
          <div>
            <span className="sidebar-nome">licmab</span>
            <span className="sidebar-sub">Painel Admin</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          {MENU_ITENS.map(item => {
            const Icone = item.icone;
            const ativo = location.pathname === item.href ||
              (item.href !== '/admin' && location.pathname.startsWith(item.href));
            return (
              <Link
                key={item.href}
                to={item.href}
                className={`sidebar-item ${ativo ? 'ativo' : ''}`}
                onClick={() => setSidebarAberta(false)}
              >
                <Icone size={18} />
                <span>{item.label}</span>
                {ativo && <ChevronRight size={14} className="sidebar-chevron" />}
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-rodape">
          <div className="sidebar-usuario">
            <div className="sidebar-avatar">
              {(usuario?.email?.[0] || 'A').toUpperCase()}
            </div>
            <div className="sidebar-info">
              <span className="sidebar-email">{usuario?.email}</span>
              <span className="sidebar-role">Administrador</span>
            </div>
          </div>
          <button className="sidebar-logout" onClick={handleLogout}>
            <LogOut size={16} />
            <span>Sair</span>
          </button>
        </div>
      </aside>

      {/* Conteúdo */}
      <div className="admin-conteudo">
        {/* Header mobile */}
        <header className="admin-header-mobile">
          <button
            className="admin-menu-btn"
            onClick={() => setSidebarAberta(true)}
          >
            <Menu size={22} />
          </button>
          <span className="admin-header-titulo">LICMAB Admin</span>
          <Link to="/" className="admin-ver-site" target="_blank">
            Ver site →
          </Link>
        </header>

        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
